import React from "react"

import MDBox from "materialDashboard/components/MDBox";
import MDAvatar from "materialDashboard/components/MDAvatar";
import MDTypography from "materialDashboard/components/MDTypography";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";


const StationCol = ({station}) => {
    if (!station) {
        return null;
    }

    const {name, code, geom, type} = station;

    return <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={null} name={code} size="sm" bgColor={"secondary"}>
            <Icon>{type === "ITINERANT" ? "hiking" : "device_thermostat"}</Icon>
        </MDAvatar>
        <MDBox ml={2} lineHeight={1}>
            <MDTypography display="block" variant="button" fontWeight="medium">
                {code} {name}
            </MDTypography>

            <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="flex-start">
                <Icon>place</Icon>
                <MDTypography variant="caption">
                    {geom.coordinates[1].toFixed(5)}, {geom.coordinates[0].toFixed(5)}
                </MDTypography>
            </Stack>
        </MDBox>
    </MDBox>;
}

export default StationCol;